import { useDeleteOrganizationMutation } from '@/queries/organizations.queries';
import { useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export function useTeamList() {
	const { t } = useTranslation();
	const deleteTeamMutation = useDeleteOrganizationMutation();
	const toast = useToast();
	const isLoading = deleteTeamMutation.isPending;

	function handleDeleteTeamClick(id: string) {
		const confirm = window.confirm(t('Are you sure you want to delete this team?'));

		if (!confirm) {
			return;
		}

		return deleteTeamMutation
			.mutateAsync(id)
			.then(() => {
				toast({ isClosable: true, title: t('Success'), status: 'success' });
			})
			.catch(() => {
				toast({ isClosable: true, title: t('Error'), status: 'error' });
			});
	}

	return {
		isLoading,
		handleDeleteTeamClick,
		t,
	};
}
